import { render } from "./LanguageChanger.vue?vue&type=template&id=c8553312"
import script from "./LanguageChanger.vue?vue&type=script&lang=js"
export * from "./LanguageChanger.vue?vue&type=script&lang=js"

import "./LanguageChanger.vue?vue&type=style&index=0&id=c8553312&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__